import { transparentize } from 'polished';
import React from 'react';
import styled, { keyframes } from 'styled-components';
const colors = {
    black: '#000000',
    white: '#ffffff',
    grey: '#cacaca',
    red: '#f74141',
    green: '#0ccb52',
    yellow: '#f5d318',
    blue: '#1a74e2',
    magenta: '#bb6ef7',
    cyan: '#16ecec',
};
export const Cursor = {
    text: '▮',
    color: 'white',
    background: 'white',
    blink: true,
};
const DisplayContainer = styled.div `
  position: relative;
  padding: 4px 8px;
  width: 100%;
  min-height: 100vh;
  font-size: 13px;
  line-height: 18px;
  background: ${colors.black};
  color: ${colors.white};

  /* &::before {
    content: ' ';
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    background: linear-gradient(rgba(0, 0, 0, 0) 50%, ${transparentize(0.75, colors.black)} 50%),
      linear-gradient(
        90deg,
        ${transparentize(0.94, '#ff0000')},
        ${transparentize(0.98, '#00ff00')},
        ${transparentize(0.94, '#0000ff')}
      );
    background-size: 100% 2px, 3px 100%;
    pointer-events: none;
    z-index: 2;
  } */
`;
const DisplayLine = styled.div `
  min-height: 18px;

  span {
    word-break: break-all;
    white-space: break-spaces;
  }

  a {
    color: ${colors.blue};
  }
`;
const blink = keyframes `
  0% {
    opacity: 1;
  }
  25% {
    opacity: 1;
  }
  26% {
    opacity: 0;
  }
  75% {
    opacity: 0;
  }
  76% {
    opacity: 1;
  }
  100% {
    opacity: 1;
  }
`;
// TODO - should be able to apply to all background and color combinations
const blinkInverse = keyframes `
  0% {
    background-size: 100%;
    color: ${colors.black};
  }
  25% {
    background-size: 100%;
    color: ${colors.black};
  }
  26% {
    background-size: 0;
    color: ${colors.white};
  }
  75% {
    background-size: 0;
    color: ${colors.white};
  }
  76% {
    background-size: 100%;
    color: ${colors.black};
  }
  100% {
    background-size: 100%;
    color: ${colors.black};
  }
`;
const StyledText = styled.span `
  color: ${({ color }) => (color ? colors[color] : '')};
  ${({ background }) => !background
    ? ''
    : `
    background-repeat: no-repeat;
    background-size: 100%;
    background-position: 0 center;
    background-image: linear-gradient(to bottom, transparent 0, ${colors[background]} 0);
  `}
  font-weight: ${({ bold }) => (bold ? 'bold' : '')};
`;
const BlinkText = styled(StyledText) `
  animation: ${blink} 1.2s infinite;
  user-select: none;
`;
const BlinkInverseText = styled(StyledText) `
  animation: ${blinkInverse} 1.2s infinite;
`;
const renderText = (key, { text, color, background, bold, blink }) => {
    let content;
    if (typeof text === 'string') {
        const urlMatch = text.match(/https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)/);
        if (!urlMatch) {
            content = text;
        }
        else {
            const [url] = urlMatch;
            const prefixText = text.slice(0, urlMatch.index);
            const suffixText = text.slice(urlMatch.index + url.length);
            content = (React.createElement(React.Fragment, null,
                prefixText,
                React.createElement("a", { href: url, target: "_blank" }, url),
                suffixText));
        }
    }
    else {
        content = text.map((t, i) => renderText(i, t));
    }
    let Tag;
    if (!blink) {
        Tag = StyledText;
    }
    else if (color === background && color === 'white') {
        Tag = BlinkText;
    }
    else {
        Tag = BlinkInverseText;
    }
    return (React.createElement(Tag, { key: key, color: color, background: background, bold: bold }, content));
};
export const Display = ({ content }) => (React.createElement(DisplayContainer, null, content.map((line, i) => (React.createElement(DisplayLine, { key: +i },
    React.createElement("pre", null, renderText(i, line)))))));
//# sourceMappingURL=data:application/json;base64,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